export const USER_LANGUAGE_KEY = "UserLocaleCode";
